<div class="row no-gutters">
    <div class="col-12 mt-4"><b>Device History</b></div>
    <div *ngIf="deviceDates && deviceDates.length>0; else noDeviceDates" class="col-12 my-3 table-responsive">
      <table class="table tbl-scrollable">
        <tbody class="max-height-57">
          <tr *ngFor="let deviceDate of deviceDates; let i = index">
            <td>
              <span class="text-secondary">{{deviceDate.key|customText}} : </span>
              <span *ngIf="deviceDate.value; else noDate">{{deviceDate.value | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</span>
              <ng-template #noDate><span>-</span></ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template class="col-12" #noDeviceDates>
      <div class="col-12 my-3 font13-400">
        Device history is not available.
      </div>
    </ng-template>
  </div>